import ArrayUtil from "../utils/ArrayUtil";
import TableUtil from "../utils/TableUtil";


export default class AppManager {
    constructor(app) {
        this.app = app
        this.arrayUtil = new ArrayUtil()
    }

    getTable(tableId) {
        return this.arrayUtil.get(this.app.tables, tableId)
    }

    getNameOrTitleField(tableId) {
        let table = this.getTable(tableId)

        if(table) {
            for( let j = 0; j < table.fields.length; j++ ) {
                let field = table.fields[j]

                if(field.name.toLowerCase().indexOf('name') > -1 || field.name.toLowerCase().indexOf('title') > -1) {
                    return field
                }
            }
        }

        return null
    }

    getFieldByType(tableId, fieldType) {
        let table = this.getTable(tableId)

        if(table) {
            for( let j = 0; j < table.fields.length; j++ ) {
                let field = table.fields[j]

                if(field.field_type === fieldType) {
                    return field
                }
            }
        }

        return null
    }

    getField(fieldId) {

        for( let i = 0; i < this.app.tables.length; i++ ) {
            let table = this.app.tables[i]

            for( let j = 0; j < table.fields.length; j++ ) {
                let field = table.fields[j]

                if(field.index === fieldId) {
                    return field
                }
            }
        }

        return null
    }

    getIntegrationOptions() {
        let options = []

        for( let i = 0; i < this.app.integrations.length; i++ ) {
            let integration = this.app.integrations[i]

            if( integration.name === 'Slack' ) {

                let slackOption = {
                    name: integration.name,
                    notifiable_id: integration.id,
                    notifiable_type: 'Integration'
                }

                options.push(slackOption)
            }
        }

        return options
    }

    getView(viewId) {

        for( let i = 0; i < this.app.tables.length; i++ ) {
            let table = this.app.tables[i]

            for( let j = 0; j < table.views.length; j++ ) {
                let view = table.views[j]

                if(view.id === viewId) {
                    return view
                }
            }
        }

        return null
    }

    getViewByName(viewName) {
        for( let i = 0; i < this.app.tables.length; i++ ) {
            let table = this.app.tables[i]

            for( let j = 0; j < table.views.length; j++ ) {
                let view = table.views[j]

                if(view.name === viewName) {
                    return view
                }
            }
        }

        return null
    }

    getCollaboratorField() {
        let tableUtil = new TableUtil()

        for( let i = 0; i < this.app.tables.length; i++ ) {
            let table = this.app.tables[i]
            let collaboratorField = tableUtil.getCollaboratorField(table)

            if(collaboratorField) {
                return collaboratorField
            }
        }

        return null
    }

    getViews() {
        let views = []

        for( let i = 0; i < this.app.tables.length; i++ ) {
            views = views.concat( this.app.tables[i].views );
        }

        return views
    }

    hasCustomView() {
        let views = this.getViews()
        let customViews = views.filter(view => (view.view_type === 'custom'))
        return customViews.length > 0
    }

    hasIntegration(name) {
        if(this.app.integrations && this.app.integrations.length > 0) {
            return this.app.integrations.filter(integration => (integration.name === name)).length > 0
        }

        return false
    }

    getIntegration(name) {
        let integrations = this.app.integrations.filter(integration => (integration.name === name))
        return integrations[0]
    }

    currentCollaborator() {
        return webase.utils.array.get(webase.model.app.collaborators, webase.model.currentUser.id, 'user_id')
    }
}